import { Icon } from '~/chords/Icon';
import type { IconName, IconSize, IconVariant } from '~/chords/Icon/types';
import { cn } from '~/lib/cn';

/** Matches TanStack `Column.getIsSorted()` (unsorted / asc / desc). */
export type SortIconDirection = false | 'asc' | 'desc';

export interface SortIconProps {
  direction: SortIconDirection;
}

export function SortIcon({ direction }: SortIconProps) {
  let iconSize: IconSize = 'md';
  let type: IconName = 'arrow-up-arrow-down';
  let variant: IconVariant = 'light';

  if (direction === 'asc') {
    iconSize = 'sm';
    type = 'arrow-up';
    variant = 'solid';
  } else if (direction === 'desc') {
    iconSize = 'sm';
    type = 'arrow-down';
    variant = 'solid';
  }

  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 align-middle leading-none [&_i]:leading-none',
        direction ? 'text-strong' : 'text-subtle',
      )}
    >
      <Icon aria-hidden size={iconSize} type={type} variant={variant} />
    </span>
  );
}

SortIcon.displayName = 'SortIcon';
